import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import './Navigation.css'

function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [userMenuOpen, setUserMenuOpen] = useState(false)
  const location = useLocation()
  const { isAuthenticated, isAdmin, user, logout } = useAuth()

  const isActive = (path) => {
    return location.pathname === path ? 'active' : ''
  }

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setMobileMenuOpen(false)
    setUserMenuOpen(false)
  }

  const toggleUserMenu = () => {
    setUserMenuOpen(!userMenuOpen)
  }

  const handleLogout = async () => {
    await logout()
    closeMobileMenu()
  }

  return (
    <nav className="main-nav">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMobileMenu}>
          <span className="nav-wordmark">Wingbeat</span>
        </Link>

        <button 
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link 
            to="/" 
            className={isActive('/')}
            onClick={closeMobileMenu}
          >
            Home
          </Link>
          <Link 
            to="/sites" 
            className={isActive('/sites')}
            onClick={closeMobileMenu}
          >
            Sites
          </Link>
          <Link 
            to="/wind-rose" 
            className={isActive('/wind-rose')}
            onClick={closeMobileMenu}
          >
            Wind Rose
          </Link>
          <Link 
            to="/flight-logs" 
            className={isActive('/flight-logs')}
            onClick={closeMobileMenu}
          >
            Flight Logs
          </Link>
          <Link 
            to="/news" 
            className={isActive('/news')}
            onClick={closeMobileMenu}
          >
            News
          </Link>
          <a
            href="https://holfuy.com/en/weather/1801"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMobileMenu}
          >
            Weather
          </a>
          <a
            href="https://shop.spreadshirt.co.uk/wingbeat"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMobileMenu}
          >
            Shop
          </a>

          {/* User Menu - Only show when authenticated */}
          {isAuthenticated && (
            <div className="user-menu">
              <button 
                className="user-menu-toggle"
                onClick={toggleUserMenu}
                aria-label="User menu"
              >
                <span className="user-icon">👤</span>
                {user?.email?.split('@')[0] || 'User'}
                <span className="dropdown-arrow">▼</span>
              </button>
              
              {userMenuOpen && (
                <div className="user-dropdown">
                  <Link 
                    to="/profile" 
                    className="dropdown-link"
                    onClick={closeMobileMenu}
                  >
                    Profile
                  </Link>
                  {isAdmin && (
                    <Link 
                      to="/admin" 
                      className="dropdown-link"
                      onClick={closeMobileMenu}
                    >
                      Admin
                    </Link>
                  )}
                  <button 
                    onClick={handleLogout}
                    className="dropdown-link logout-btn"
                  >
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </nav>
  )
}

export default Navigation
